import { DataType } from '@/util/index'
const ACTION = DataType.PaymentScheduleAction
const SINGLE_PAYMENT_SCHEDULE_ACTION = {
  ASSIGNED_MODE: {
    title: ACTION.ASSIGNED_MODE.text,
    value: ACTION.ASSIGNED_MODE.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_MODE,
    fieldClass: 'lg12',
    fields: [
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } }
    ]
  },
  ASSIGNED_DATE: {
    title: ACTION.ASSIGNED_DATE.text,
    value: ACTION.ASSIGNED_DATE.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_DATE,
    fieldClass: 'lg12',
    fields: [
      { label: 'Disbursement Date', fieldKey: 'transactionDate', template: '{transactionDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend' }
    ]
  },
  ASSIGNED_AMOUNT: {
    title: ACTION.ASSIGNED_AMOUNT.text,
    value: ACTION.ASSIGNED_AMOUNT.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_AMOUNT,
    limitValue: true,
    fieldClass: 'lg12',
    fields: [
      { label: 'Principal', fieldKey: 'principal', template: '{principal}', format: 'currency', controlType: 'checkbox-input', disabled: true },
      { label: 'Interest', fieldKey: 'interest', template: '{interest}', format: 'currency', controlType: 'checkbox-input', disabled: true },
      { label: 'Unpaid Fee', fieldKey: 'unpaidFee', template: '{unpaidFee}', format: 'currency', controlType: 'checkbox-input', disabled: true }
    ]
  },
  ASSIGNED_SKIP: {
    title: ACTION.ASSIGNED_SKIP.text,
    value: ACTION.ASSIGNED_SKIP.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_SKIP,
    fieldClass: 'lg12',
    fields: [
      // nothing in V2
    ]
  },
  MANUAL_REJECT: {
    title: ACTION.MANUAL_REJECT.text,
    value: ACTION.MANUAL_REJECT.value,
    privilegeCode: DataType.PrivilegeCode.MANUAL_REJECT,
    hasFile: true,
    fieldClass: 'lg12',
    fields: [
      { label: 'ReturnCode', fieldKey: 'returnCode', template: '{returnCode}', controlType: 'requestSelectItems' },
      { label: 'Reason', fieldKey: 'reason', template: '{reason}', couldEmpty: true }
    ]
  },
  MANUAL_REJECT_FOR_WA: {
    title: ACTION.MANUAL_REJECT.text,
    value: ACTION.MANUAL_REJECT.value,
    privilegeCode: DataType.PrivilegeCode.MANUAL_REJECT,
    fieldClass: 'lg12',
    fields: []
  },
  MANUAL_CHECKED: {
    title: ACTION.MANUAL_CHECKED.text,
    value: ACTION.MANUAL_CHECKED.value,
    privilegeCode: DataType.PrivilegeCode.MANUAL_CHECKED,
    hasFile: true,
    fieldClass: 'lg12',
    fields: []
  },
  ASSIGNED_MAKEUP: {
    title: ACTION.ASSIGNED_MAKEUP.text,
    value: ACTION.ASSIGNED_MAKEUP.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_MAKEUP,
    fieldClass: 'lg12',
    fields: [
      { label: 'Disbursement Date', fieldKey: 'transactionDate', template: '{transactionDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend' }
    ]
  },
  ASSIGNED_MAKEUP_PARTIAL: {
    title: ACTION.ASSIGNED_MAKEUP_PARTIAL.text,
    value: ACTION.ASSIGNED_MAKEUP_PARTIAL.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_MAKEUP,
    limitValue: true,
    fieldClass: 'lg12',
    fields: [
      { label: 'Max Partial Amount', fieldKey: 'maxPartialAmount', template: '{maxPartialAmount}', format: 'currency', controlType: 'spanWithText' },
      { label: 'Disbursement Date', fieldKey: 'transactionDate', template: '{transactionDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend' },
      { label: 'Amount', fieldKey: 'amount', template: '{amount}', format: 'currency' }
    ]
  },
  REFUND_PAYMENT: {
    title: ACTION.REFUND_PAYMENT.text,
    value: ACTION.REFUND_PAYMENT.value,
    privilegeCode: DataType.PrivilegeCode.REFUND_PAYMENT,
    limitValue: true,
    fieldClass: 'lg12',
    fields: [
      { label: 'Disbursement Date', fieldKey: 'transactionDate', template: '{transactionDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend' },
      { label: 'Amount', fieldKey: 'amount', template: '{amount}', format: 'currency', disabled: true },
      { label: 'Refund Fee', fieldKey: 'refundFee', template: '{refundFee}', format: 'currency' },
      { label: 'Bank Fee', fieldKey: 'bankFee', template: '{bankFee}', format: 'currency', couldEmpty: true }
    ]
  },
  REVERSE_DEBIT: {
    title: ACTION.REVERSE_DEBIT.text,
    value: ACTION.REVERSE_DEBIT.value,
    privilegeCode: DataType.PrivilegeCode.REVERSE_DEBIT,
    fieldClass: 'lg12',
    fields: []
  },
  CANCEL_CHANGE: {
    title: ACTION.CANCEL_CHANGE.text,
    value: ACTION.CANCEL_CHANGE.value,
    privilegeCode: DataType.PrivilegeCode.CANCEL,
    fieldClass: 'lg12',
    fields: []
  }
}
export default SINGLE_PAYMENT_SCHEDULE_ACTION
